import { postApi } from './api_instance'

export const emailotpRequest = async ({ email, userType }, dispatch) => {
  try {
    const { data } = await postApi({
      apiUrl: '/api/user/kyc/generateOTP',
      sendToken: true,
      dispatch,
      data: { email, user_type: userType }
    })
    return data
  } catch (error) {
    throw error
  }
}
